<template>
    <div class="position-box delegateList">
        <div class="head">
            <img class="back" src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('jghy.cclb')}}</div>
        </div>
        <ul class="type-box positionList">
            <li class="type" :class="{active: tabIdx == 1}" @click="tab(1)">{{$t('jghy.zc')}}</li>
            <li class="type text-center" :class="{active: tabIdx == 2}" @click="tab(2)">{{$t('jghy.lscc')}}</li>
            <li class="type select-type text-right" @click.stop="down">
                <div class="text">{{typeText}}</div>
                <img class="down" src="@/assets/new/down.png" alt="">
            </li>
        </ul>
         <div class="scroll"  @scroll="listenScroll">
            <ul class="cont-box jgcc">
                <li class="list" v-for="(item,index) in orderData" :key="index">
                    <div class="list-head">
                        <div class="type">{{item.currency_name}}</div>
                        <div class="status">{{item.open_time | timeGs}}</div>
                    </div>
                    <div class="list-body">
                        <div class="list-item">
                            <div>{{$t('jghy.fx')}}</div>
                            <div class="t1" :class="{red: item.type == 2}">{{item.type | fx}}</div>
                        </div>
                        <div class="list-item">
                            <div>{{$t('jghy.sl')}}</div>
                            <div class="t2">{{item.amount}}</div>
                        </div>
                        <div class="list-item">
                            <div>{{$t('jghy.jgsj')}}</div>
                            <div class="t2">{{item.cut_time}} S</div>
                        </div>
                        <div class="list-item" v-show="status == 2">
                            <div>{{$t('jghy.gmj')}}</div>
                            <div class="t2">{{item.price}}</div>
                        </div>
                        <div class="list-item" v-show="status == 2">
                            <div>{{$t('jghy.jsj')}}</div>
                            <div class="t2">{{item.close_price}}</div>
                        </div>
                        <div class="list-item">
                            <div>{{$t('jghy.yk')}}</div>
                            <div class="t1" :class="{red: item.profit_loss < 0}" >{{item.profit_loss}}</div>
                        </div>
                    </div>
                    <div class="list-foot" v-show="tabIdx ==1 ">
                        <div class="btn" @click="detail(item.id,item.currency_name,item.type,1)">{{$t('kxt.djck')}}</div>
                    </div>
                </li>
            </ul>
            <!-- 暂无数据 -->
            <no-data v-show="isNoData"></no-data>
            <div class="mask" v-show="isDown" @click="down"></div>
            <ul class="select-box select-box3" v-show="isDown">
                <li class="select" data-type="1" v-for="(item,index) in bzData" @click.stop="select(item.name)" :key="index">{{item.name}}</li>
            </ul>
            <img class="go-top" src="@/assets/top.png" alt="" @click="scrollTo" v-show="isTop">
        </div>
        <div class="mask" v-show="isMask" @click="close"></div>
        <!-- 订单确认 -->
        <div class="alert-wrap" v-show="isJgShow">
            <div class="alert-box">
                <div class="alert-head order-head">
                    <div class="title">{{$t('jghy.ddqr')}}</div>
                    <div><img class="close" src="@/assets/new/close.png" alt="" @click="close"></div>
                </div>
                <div class="alert-tips">{{$t('jghy.dqsj')}}</div>
                <div class="time-wrap">
                    <ul class="time-box">
                        <li class="time-item" :class="{active: timeIdx == index}" v-for="(item,index) in cutTimeList" :key="item.id" @click="timeSelect(index,item)">
                            <div class="t1">{{$t('jghy.jgsj')}}</div>
                            <div class="time" v-if="item.time == 3600"><span class="num">1</span> H</div>
                            <div class="time" v-else-if="item.time == 43200"><span class="num">12</span> H</div>
                            <div class="time" v-else-if="item.time == 86400"><span class="num">24</span> H</div>
                            <div class="time" v-else><span class="num">{{item.time / 60}}</span> min</div>
                            <div class="t2"><span>{{$t('jghy.sy')}} </span>{{item.rate}}%</div>
                            <img class="icon" src="@/assets/new/select.png" v-show="timeIdx == index" alt="">
                        </li>
                    </ul>
                </div>
                <div class="alert-tips">{{$t('jghy.tzje')}}</div>
                <div class="input-box">
                    <input class="input" type="number" v-model="tzmoney" :placeholder="placeholder" @keyup="keyMoney()">
                    <div class="text">USDC</div>
                </div>
                <div class="ky-box">
                    <div class="text"><span>{{$t('jghy.kyye')}}</span><span v-show="isKyZcShow" class="money">{{useBalance}}</span><span v-show="!isKyZcShow" class="money">******</span><img class="icon" v-show="!isKyZcShow" src="@/assets/new/eyes.png" @click="change" alt="" /><img class="icon" src="@/assets/new/eyes2.png" v-show="isKyZcShow" @click="change" alt=""></div>
                    <div class="text"><span>{{$t('jghy.sxf')}}</span>{{rate}}%</div>
                </div>
                <div class="trade-wrap">
                    <div class="trade-box">
                        <div class="text">{{$t('jghy.jypz')}}</div>
                        <div class="text text-center">{{$t('jghy.jyfx')}}</div>
                        <div class="text text-right">{{$t('jghy.xj')}}</div>
                    </div>
                    <div class="trade-box trade-item">
                        <div class="text t1">{{symbol}}</div>
                        <div class="text t2 text-center" :class="{active: fx == 2}">{{fxText}}</div>
                        <div class="text t3 text-right">{{newprice | toFixed4}}</div>
                    </div>
                </div>
                <div class="alert-btn-box">
                    <button id="order" type="button" class="btn order" @click="order(1)">{{$t('jghy.qrxd')}}</button>
                </div>
            </div>
        </div>
        <div class="alert-wrap" v-show="isJgTime">
            <div class="alert-box">
                <div class="alert-head">
                    <div class="title">{{detailData.currency_name}}</div>
                    <div><img class="btn-close" src="@/assets/new/close.png" alt="" @click="close"></div>
                </div>
                 <!-- 结果 -->
                 <div class="price-box" v-show="is_close">
                     <div v-show="detailData.is_close == 1"><span>{{$t('jghy.yk')}}</span> <span class="num" v-if="detailData.profit_loss == 0">0</span><span class="num" v-else :class="{red: detailData.profit_loss < 0}">{{detailData.profit_loss | toFixed4}}</span> USDC</div>
                     <div v-show="detailData.is_close == 0" style="color: #4bb3e8; font-size: 15px;" >{{$t('tipsNew.ddz')}}</div>
                 </div>
                 <!-- 结果 -->
                <div class="circle-box" v-show="!is_close">
                    <div id="times" class="text">{{detailData}}{{detailData.cut_time}} S</div>
                    <svg class="circle" width="84" height="84">
                        <circle cx="40" cy="40" r="36" fill="transparent" stroke="#4bb3e8" stroke-width="6"></circle>
                        <circle id="circle" class="alert-sec-circle" cx="40" cy="40" r="36" fill="transparent" stroke="#232a44" stroke-width="8" transform="rotate(-90 40 40)"></circle> </svg>
                </div>
                <ul class="item-box">
                    <li class="item" v-show="is_close">
                        <div>{{$t('jghy.jsj')}}</div>
                        <div class="t1">{{detailData.close_price}}</div>
                    </li>
                    <li class="item" v-show="!is_close">
                        <div>{{$t('jghy.gmj')}}</div>
                        <div class="t1">{{detailData.price}}</div>
                    </li>
                    <li class="item" v-show="!is_close">
                        <div>{{$t('jghy.xj')}}</div>
                        <div class="t2">{{newprice | toFixed4}}</div>
                    </li>
                    <li class="item">
                        <div>{{$t('jghy.fx')}}</div>
                        <div class="t2" :class="{red: detailData.type == 2}">{{detailData.type | fx}}</div>
                    </li>
                    <li class="item">
                        <div>{{$t('jghy.sl')}}</div>
                        <div class="t1">{{detailData.amount}}</div>
                    </li>
                    <li class="item">
                        <div>{{$t('jghy.jgsj')}}</div>
                        <div class="t1">{{detailData.cut_time}} S</div>
                    </li>
                    <li class="item" v-show="is_close">
                        <div>{{$t('jghy.dqye')}}</div>
                        <div class="t1">{{detailData.hy_usdt}}</div>
                    </li>
                </ul>
                <div class="alert-btn-box">
                    <button type="button" class="btn close" @click="close">{{$t('jghy.gb')}}</button>
                    <button type="button" class="btn order" @click="agin">{{$t('jghy.jxxd')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import noData from '@/components/noData.vue'
import VueBetterScroll from 'vue2-better-scroll'
let that = this;
let vm = null;
export default {
    name: 'positionList',
    data () {
        return {
            isNoData: false,
            isGoTOP: false,
            isDown: false,
            isMask: false,
            currency: '',
            bzData: [],
            tabIdx: 1,
            timeIdx: 0,
            status: 1,//1.在持，2.历史
            type: 1,//1买涨，2买跌
            symbol: '',
            orderId: '',
            cutTimeList: [],
            orderData: [],
            detailData: {
              "profit_loss": 0
            },
            timeObj: {},
            curDataLength: 10,
            tzmoney: '',//投资金额
            newprice: '0.0000',
            xianjia: '',//现价
            fxText: '',//方向文本
            fx: 1,
            rate: '',//手续费
            useBalance: '',//可用余额
            orderId: '',
            timer: null,
            timerTimes: null,
            timerOrder: null,
            orderTimes: null,
            is_close: false,
            isJgShow: false,
            isJgTime: false,//交割倒计时
            isScroll: false,//是否滚动到底部
            close_time_set_stamp: '',
            theme: false,
            page: 1,
            limit: 10,
            placeholder: '',
            count: 1,
            isKyZcShow: false,
            typeText: this.$t('jghy.qblx'),
            scrollToTime: 500,
            isTop: false,
        }
    },
    beforeCreate(){
      that = this;
      vm = this;
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      let kyZcShow = localStorage.getItem('kyZcShow');
      if(kyZcShow == null || kyZcShow == 'false'){
          localStorage.setItem('kyZcShow',false);
          this.isKyZcShow = false
      }else{
          localStorage.setItem('kyZcShow',true);
          this.isKyZcShow = true
      }
    },
    mounted() {
      this.getOrderList();//获取记录
      this.getmarketList();
      this.timerOrder = setInterval(() =>{
          this.getOrderList();
          this.daymarket();
      },2000)
    },
    methods: {
       back(){
           this.$router.push('/contractTransaction')
       },
       scroll({x, y}){
            if(Math.abs(y) >= 300){
                this.isTop = true;
            }else{
                this.isTop = false
            }
        },
        // 滚动到页面顶部
        scrollTo() {
            this.$refs.scroll.scrollTo(this.scrollToY, this.scrollToTime)
        },
       change(){
          this.isKyZcShow = !this.isKyZcShow;
          localStorage.setItem('kyZcShow',this.isKyZcShow)
      },
      down(){
        this.isDown = !this.isDown;
      },
      select(curText){
        this.page = 1;
        this.orderData = [];
        this.currency = this.typeText = curText;
        this.isDown = false;
        this.getOrderList();
      },
      tab(idx){
          this.page = 1;
          this.orderData = [];
          this.tabIdx = idx;
          this.status = idx;
          $('.select-box').hide();
          this.getOrderList();
          if(idx == 1){
              this.timerOrder = setInterval(() =>{
                  this.getOrderList();
              },2000)
          }else{
              clearInterval(this.timerOrder);
              this.timerOrder = null;
          }
      },
      getmarketList(){
          let params = {
            id: 1,
            type: 1
          }
          this.$ajax.get('/web/getmarketList',{params}).then((res) => {
              let resData = res.data.data;
              this.bzData = resData;
          }).catch(function(err){
              console.log(err)
          })
      },
      detail(id,symbol,type,isDetail){
          this.isMask = true;
          this.isJgTime = true;
          this.is_close = false;
          this.orderId = id;
          this.currency = symbol.split('/')[0];
          this.symbol = symbol;
          if(type == 1){
              this.fxText = this.$t('jghy.mz');
          }else{
              this.fxText = this.$t('jghy.md');
          }
          $('#times').html('');
          clearInterval(this.timerTimes);
          this.timerTimes = null;
          clearInterval(this.orderTimes);
          this.orderTimes = null;
          document.getElementById("circle").style.strokeDashoffset = 0;
          this.getOrderDetail(isDetail);
          this.daymarket();
          this.getAsset();
      },
      getAsset(){
          let params = {
            type:2,
            currency:this.currency
          }
          this.$ajax.get('/web/getInfo',{params}).then((res) => {
              let resData = res.data.data;
              this.useBalance =  (Number(resData.wallet.usdt)).toFixed(4);
          }).catch(function(err){
              console.log(err)
          })
      },
      getCutTimeList(){//获取交割时间
          this.$ajax.get('/web/cutTimeList',{}).then((res) => {
              let resData = res.data.data;
              this.cutTimeList = resData.list;
              this.timeObj = resData.list[this.timeIdx];
              this.placeholder = this.$t('tipsNew.zxtzsl') + this.timeObj.amount_min;
              this.rate = resData.rate;
          }).catch(function(err){
              console.log(err)
          })
      },
      getOrderDetail(isDetail){
          let that = this;
          let params = {
            id: that.orderId
          }
          clearInterval(that.timerTimes);
          that.timerTimes = null;
          $('#times').html('');
          clearInterval(that.orderTimes);
          that.orderTimes = null;
          this.$ajax.get('/web/cutOrder',{params}).then((res) => {
              let resData = res.data.data;
              that.detailData = resData;
              if(that.is_close){
                  if(resData.is_close != 1){
                      that.orderTimes = setInterval(() => {
                          that.getOrderDetail(0);
                      },1000);
                  }else{
                      clearInterval(that.orderTimes);
                      that.orderTimes = null;
                  }
                  return false;
              }
              if(isDetail == 1){
                  that.endTimes(res.data.time,resData.close_time_set_stamp,resData.cut_time)
              }else{
                  that.downTimes(resData.cut_time)
              }
          }).catch(function(err){
              console.log(err)
          })
      },
      downTimes(cutTime){
          var that = this;
          var t = cutTime;
          n = document.getElementById("circle");
          $('#times').html('');
          if(that.is_close){
              $('#times').html('');
              clearInterval(that.timerTimes);
              that.timerTimes = null;
              clearInterval(that.orderTimes);
              that.orderTimes = null;
              return false;
          }else{
              that.timerTimes = setInterval(()=> {
                  var that = this;
                  if (t <= 0){
                      $('#times').html('');
                      that.is_close = true;
                      setTimeout(()=>{
                          that.getOrderDetail(0)
                      },2000);
                      clearInterval(that.orderTimes);
                      that.orderTimes = null;
                  }else {
                      t -= 1;
                      $('#times').html( t + ' ' + 'S');
                      let e = Math.floor(t / cutTime * 240);
                      n.style.strokeDashoffset = e - 240;
                  }
              },1000);
          }
      },
      endTimes(curTimes,date,cut_time){
          var that = this;
          var n = document.getElementById("circle");
          $('#times').html('');
          let nowtime = curTimes * 1000; // 当前时间 毫秒数
          let endTime = date * 1000; //结束时间  毫秒数
          let totalSeconds = parseInt((endTime - nowtime) / 1000);
          let t = parseInt((endTime - nowtime) / 1000); // 结束时间-当前时间 = 剩余多少时间
          if(that.is_close){
              clearInterval(that.timerTimes);
              document.getElementById("circle").style.strokeDashoffset = 0;
              clearInterval(that.orderTimes);
              that.timerTimes = null;
              that.orderTimes = null;
              return false;
          }else{
              that.timerTimes = setInterval(()=> {
                  var that = this;
                  if (t <= 0){
                      $('#times').html('');
                      that.is_close = true;
                      setTimeout(()=>{
                          that.getOrderDetail(0)
                      },2000);
                      clearInterval(that.orderTimes);
                      that.orderTimes = null;
                  }else {
                      t -= 1;
                      $('#times').html( t + ' ' + 'S');
                      let e = Math.floor(t / cut_time * 240);
                      n.style.strokeDashoffset = e - 240;
                  }
              },1000);
          }
      },
      timeSelect(idx,obj){
          this.timeIdx = idx;
          this.timeObj = obj;
          this.tzmoney = '';
          this.placeholder = this.$t('tipsNew.zxtzsl') + obj.amount_min;
      },
      close(){
          this.isJgShow = false;
          this.isJgTime = false;
          this.isMask = false;
          this.is_close = false;
          this.tzmoney = '';
          this.count = 1;
          $('#order').css('background','#4bb3e8');
          clearInterval(this.timerTimes);
          this.timerTimes = null;
          clearInterval(this.orderTimes);
          this.orderTimes = null;
          $('#times').html('');
          document.getElementById("circle").style.strokeDashoffset = 0;
      },
      getOrderList(){
          let that = this;
          let params = {
              status: that.status,
              currency: that.currency,
              limit: that.limit,
              page: that.page
          }
          this.$ajax.get('/web/cutOrderList',{params}).then((res) => {
              let resData = res.data.data;
              if(res.data.code == 1000){
                setTimeout(()=>{
                  this.$router.push('/index');
                },1000)
                return false
              }
              if(resData.list.length > 0){
                if(that.isScroll){
                    that.orderData = that.orderData.concat(resData.list);
                }else{
                    that.orderData = resData.list;
                }
                that.curDataLength = resData.list.length;
              }else{
                  clearInterval(that.timerOrder);
                  that.timerOrder = null;
                  if(that.status == 1 && that.page == 1){
                      that.orderData = []
                  }
                  that.curDataLength = resData.list.length;
              }
              if(that.orderData.length > 0){
                  that.isNoData = false;
              }else{
                  that.isNoData = true;
              }
            }).catch(function(err){
                console.log(err)
            })
      },
      setIntervalTime(curTimes){
          setInterval(() => {
              timer = this.orderData.forEach(item => {
                  item.close_time_set_stamp = this.countTime(curTimes,item.close_time_set_stamp)
              })
          },1000)
      },
      order(){//下单
          clearInterval(this.timerTimes);
          this.timerTimes = null;
          clearInterval(this.orderTimes);
          this.orderTimes = null;
          $('#times').html('');
          this.detailData = {};
          let that = this;
          let params = {
              currency: this.currency,
              amount: this.tzmoney,
              type: this.fx,
              timeid: this.timeObj.id
          }
          if(that.tzmoney == '' || that.tzmoney == null){
              this.$toast.center(this.$t('xbsg.qsrsl'));
              return false;
          }else if(that.tzmoney <= 0){
              this.$toast.center(this.$t('xbsg.qsrsl'));
              return false;
          }else if(parseFloat(that.tzmoney) < parseFloat(this.timeObj.amount_min)){
              this.$toast.center(this.$t('tipsNew.min') + this.timeObj.amount_min);
              return false;
          }else if(parseFloat(that.tzmoney) > parseFloat(this.timeObj.amount_max)){
              this.$toast.center(this.$t('tipsNew.max') + this.timeObj.amount_min);
              return false;
          }else if(parseFloat(that.tzmoney) > parseFloat(that.useBalance)){
              this.$toast.center(this.$t('tipsNew.yebz'));
              return false;
          }
          if(that.count == 1){
              that.count = 0;
              $('#order').css('background','#666')
          }else{
              $('#order').css('background','#666')
              return false;
          }
          this.$ajax.post('/web/cutBuy',params).then((res) => {
            let resData = res.data;
            if(resData.code == 0 || resData.code == 4 || resData.code == 7){
              this.$toast.center(resData.message);
              that.page = 1;
              that.isMask = false;
              that.isJgTime = false;
              that.isJgShow = false;
              that.is_close = false;
              that.getAsset();
              that.getOrderList();
              setTimeout(()=>{
                  that.count = 1;
                  $('#order').css('background','#4bb3e8');
              },2000)
            }else{
                that.count = 1;
                $('#order').css('background','#4bb3e8');
                this.$toast.center(resData.message);
                return;
            }
          }).catch(function(err){
              console.log(err)
          })
      },
      agin(){
          this.isMask = true;
          this.isJgTime = false;
          this.isJgShow = true;
          this.is_close = false;
          this.tzmoney = '';
          this.count = 1;
          $('#order').css('background','#4bb3e8');
          this.getCutTimeList();
          this.getAsset();
          clearInterval(this.timerTimes);
          this.timerTimes = null;
          clearInterval(this.orderTimes);
          this.orderTimes = null;
          $('#times').html('');
          document.getElementById("circle").style.strokeDashoffset = 0;
      },
      daymarket(){
          var that = this;
          var currency;
          if(that.detailData.currency == undefined){
              currency = 'BTC'
          }else{
              currency = that.detailData.currency
          }
          let params = {
            symbol: currency+'usdt'
          }
          this.$ajax.get('/web/new_data',{params}).then((res) => {
            let resData = res.data.data;
            let daymarket = JSON.parse(resData.daymarket);
            that.newprice = daymarket.now_price;
          }).catch(function(err){
              console.log(err)
          })
      },
      listenScroll(e) {  //监听滚动
              let ele = e.srcElement ? e.srcElement : e.target;
              clearInterval(this.timerOrder);
              this.timerOrder = null;
              if(ele.scrollTop > 200){
                  this.isGoTOP = true
              }else{
                  this.isGoTOP = false
              }
              if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
                if(this.curDataLength >= this.limit){
                                  this.isScroll = true;
                  this.page ++;
                  this.getOrderList();
                }else{
                  this.isScroll = false
                }
              }
      },
      countTime(curTimes,end){
          var nowtime = curTimes * 1000; // 当前时间 毫秒数
          var endTime = end * 1000; //结束时间  毫秒数
          var totalSeconds = (endTime - nowtime) / 1000; // 结束时间-当前时间 = 剩余多少时间
          var day = parseInt(totalSeconds / 3600 / 24); //天
          var hour = parseInt((totalSeconds / 3600) % 24); //时
          var minute = parseInt((totalSeconds / 60) % 60); //分
          var second = parseInt(totalSeconds % 60); //秒
          hour = this.addZero(hour);
          minute = this.addZero(minute);
          second = this.addZero(second);
          var residueTime = hour + shi + " " + minute + fen + " " + second + miao;
          if (totalSeconds < 0) {
              return residueTime = ' ';
          }else{
              return residueTime
          }
      },
      // 补齐格式不满10加0
      addZero (n) {
          return n < 10 ? '0' + n : n
      },
      goTop(){
        $('.scroll').animate({scrollTop:'0px'},'slow');
      },
      keyMoney(){
        this.tzmoney = this.tzmoney.replace(/[^\d.]/g, "");  //仅保留数字和"."
        this.tzmoney = this.tzmoney.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        this.tzmoney = this.tzmoney.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
        this.tzmoney = this.tzmoney.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
        if (this.tzmoney.indexOf(".") < 0 && this.tzmoney != "") { //首位是0的话去掉
            this.tzmoney = parseFloat(this.tzmoney);
        }
      },
    },
    filters:{
      fx(val){
          if(val == 1){
              return that.$t('jghy.mz')
          }else if(val == 2){
              return that.$t('jghy.md')
          }else{
              return that.$t('jghy.mz')
          }
      },
      toFixed4: function (value, options) {
          value = Number(value);
          return value.toFixed(4);
      },
      times: function (value, options) {
          if(value){
              if(value.indexOf(this.miao) > 0){
                  return value
              }else{
                  return ''
              }
          }else{
              return ''
          }
      },
  },
  components:{
    noData,
    VueBetterScroll
  },
  beforeDestroy () {
      clearInterval(this.timer);
      clearInterval(this.timerTimes);
      clearInterval(this.timerOrder);
      clearInterval(this.orderTimes);
      this.orderTimes = null;
      this.timer = null;
      this.timerTimes = null;
      this.timerOrder = null;
  },
}
</script>
<style scoped>
.position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 1.2rem;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.2rem;
        padding: 0 .44rem;
        color: #fff;
        line-height: 1.2rem;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .32rem;
        margin-top: -.3rem;
    }
    .head .title{
        font-size: .52rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .type-box{
        position: fixed;
        top: 1.6rem;
        z-index: 9;
        width: 100%;
        display: flex;
        align-items: center;
        padding: .42rem;
        box-sizing: border-box;
    }
    .type-box .type{
        position: relative;
        width: 33.33%;
        color: #7f7f7f;
        font-size: .42rem;
    }
    .type-box .type.active{
        color: #588bf8;
        font-size: .45rem;
    }
    .type-box .type.select-type{
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    .type-box .type .down{
        margin-left: .18rem;
        width: .3rem;
        height: .24rem;
    }
    .select-box{
        position: fixed;
        left: -1px;
        right: 0;
        bottom: 0;
        z-index: 1000;
        height: auto;
        max-height: 10rem;
        background: #0E1530;
        overflow-y: scroll;
    }
    .select-box .select{
        padding: .4rem 0;
        color: #7f7f7f;
        font-size: .36rem;
        border-bottom: 1px solid #313a47;
        text-align: center;
    }
    .select-box .select:last-child{
        border-bottom: none;
    }
    .scroll{
        position: absolute;
        top: 3rem;
        width: 100%;
        bottom: 0;
        height: auto;
        overflow-y: scroll;
    }
    .cont-box .list{
        margin-top: .18rem;
        padding: .42rem;
    }
    .cont-box .list .list-head{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: .3rem;
        border-bottom: 1px solid #313a47;
    }
    .cont-box .list .buy{
        padding: 2px .12rem;
        color: #fff;
        font-size: .36rem;
        border-radius: .18rem;
        background: #00c483;
    }
    .cont-box .list .sell{
        background: #d85656;
    }
    .cont-box .list .type{
        padding: 0 .3rem 0 0;
        color: #fff;
        font-weight: bold;
    }
    .cont-box .list .type span{
        color: #b5b5b5;
        font-size: .4rem;
        font-weight: normal;
    }
    .cont-box .list .date{
        color: #b5b5b5;
    }
    .cont-box .list .time{
        flex: 1;
        padding-left: .3rem;
        color: #b5b5b5;
    }
    .cont-box .list .btn-cancle{
        padding: .12rem .24rem;
        color: #218adc;
        font-size: .36rem;
        border: 1px solid #218adc;
        border-radius: .12rem;
    }
    .cont-box .list .status{
        color: #fff;
    }
    .cont-box .list .list-body{
        padding-bottom: .36rem;
        border-bottom: 1px solid #313a47;
    }
    .cont-box .list .list-body .list-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: .36rem;
        color: #aaa;
        font-size: .4rem;
    }
    .cont-box .list .list-body .list-item .t1{
        color: #00c483;
    }
    .cont-box .list .list-body .list-item .t2{
        color: #fff;
    }
    .cont-box .list .list-body .list-item .t3{
        color: #db4949;
    }
    .cont-box .list .list-foot{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: .42rem;
        font-size: .4rem;
    }
    .cont-box .list .list-foot .btn{
        width: 2.55rem;
        height: .75rem;
        color: #fff;
        line-height: .75rem;
        border-radius: .12rem;
        background: #218adc;
        text-align: center;
    }
    .cont-box .list .list-foot .date{
        color: #218adc;
    }
    .cont-box .list .list-foot.history{
        justify-content: center;
    }
    .cont-box .list .list-foot.history .date{
        color: #000;
    }
    .alert-wrap{
        position: fixed;
        z-index: 1000;
        width: 100%;
        height: 100%;
        padding: 0 .3rem;
        box-sizing: border-box;
    }
    .alert-wrap .alert-box{
        position: relative;
        top: 50%;
        width: 100%;
        padding: 0 .3rem;
        border-radius: 6px;
        background: #0f1a2a;
        transform: translateY(-50%);
        box-sizing: border-box;
    }
    .alert-wrap .alert-box .alert-head{
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:.36rem 0 .3rem;
        border-bottom: 1px solid #313a47;
    }
    .alert-wrap .alert-box .alert-head .title{
        color: #fff;
        font-size: .42rem;
    }
    .alert-wrap .alert-box .alert-head .btn-close{
        width: .42rem;
        height: .42rem;
    }
    .alert-wrap .alert-box .order-head{
        justify-content: space-between;
        border-bottom: 1px solid #313a47;
    }
    .alert-wrap .alert-box .alert-head .close{
        position: absolute;
        top: 50%;
        right: .3rem;
        width: .42rem;
        height: .42rem;
        margin-top: -.21rem;
    }
    .alert-wrap .alert-box .order-item1{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .4rem 0 .3rem;
    }
    .alert-wrap .alert-box .order-item1 .box-lt{
      display: flex;
      align-items: center;
    }
    .alert-wrap .alert-box .order-item1 .box-lt .icon{
      width: 1.22rem;
      margin-right: .35rem;
    }
     .alert-wrap .alert-box .order-item1 .t1{
       color: #fff;
       font-size: .42rem;
     }
     .alert-wrap .alert-box .order-item1 .t2{
       margin-top: .3rem;
       color: #fff;
       font-size: .42rem;
     }
     .alert-wrap .alert-box .order-item1 .time-box{
       display: flex;
       align-items: center;
     }
     .alert-wrap .alert-box .order-item1 .time-box .time-icon{
       width: .5rem;
       margin-right: .2rem;
     }
     .alert-wrap .alert-box .order-item1 .time-box .time{
       color: #fff;
       font-size: .42rem;
     }
     .alert-wrap .alert-box .order-item1 .box-rt .money{
       margin-top: .28rem;
       color: #fff;
       font-size: .42rem;
     }
    .alert-wrap .alert-box .circle-box{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2.52rem;
        height: 2.52rem;
        /* line-height: 84px; */
        margin: .24rem auto .42rem;
    }
    .alert-wrap .alert-box .circle-box .text{
        width: 80px;
        height: 80px;
        color: #4458ed;
        line-height: 80px;
        font-size: .42rem;
        text-align: center;
    }
    .alert-wrap .alert-box .circle{
        position: absolute;
        left: 50%;
        top: 50%;
        width: 80px;
        height: 80px;
        transform: translate(-50%,-50%);
    }
    .alert-sec-circle {
        stroke-dashoffset: 0;
        stroke-dasharray: 720;
        transition: stroke-dashoffset 1s linear
    }
    .alert-wrap .alert-box .price-box{
        padding: 1.11rem 0 1.38rem;
        color: #00c488;
        text-align: center;
    }
    .alert-wrap .alert-box .price-box .num{
        font-size: .6rem;
    }
    .alert-wrap .item-box{
        padding: 0 20px;
    }
    .alert-wrap .item-box .item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #c3c3c3;
        font-size: .4rem;
        padding-bottom: .54rem;
    }
    .alert-wrap .item-box .item .t1{
        color: #fff;
    }
    .alert-wrap .item-box .item .t2{
        color: #fff;
    }
    .alert-wrap .item-box .item .price{
      color: #00c488;
    }
    .alert-wrap .alert-btn-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .3rem 0 .54rem;
    }
    .alert-wrap .alert-btn-box .btn{
        height: 1.02rem;
        color: #fff;
        border-radius: .12rem;
        text-align: center;
    }
    .alert-wrap .alert-btn-box .btn.close{
        width: 106px;
        margin-right: .3rem;
        background: #367d99;
    }
    .alert-wrap .alert-btn-box .btn.order{
        flex: 1;
        background: #4458ed;
    }
    .alert-wrap .alert-tips{
        padding: .3rem 0;
        color: #fff;
        font-size: .42rem;
    }
    .alert-wrap .order-item2{
      display: flex;
      align-items: center;
    }
    .alert-wrap .order-item2 .time-box{
      display: flex;
      align-items: center;
      min-width: 3.45rem;
      padding: .22rem .38em .22rem .26rem;
      border-radius: .12rem;
      border: 1px solid #313a47;
      box-sizing: border-box;
    }
    .alert-wrap .order-item2 .time-box .icon{
      width: .58rem;
    }
    .alert-wrap .order-item2 .time-box .time{
      margin: 0 .26rem 0 .52rem;
      color: #fff;
      font-size: .42rem;
    }
    .alert-wrap .order-item2 .time-box .arrow{
        width: .4rem;
    }
    .alert-wrap .order-item2 .fx-box{
      display: flex;
      align-items: center;
      margin-left: .52rem;
    }
    .alert-wrap .order-item2 .fx-box .bg-box{
      position: relative;
    }
    .alert-wrap .order-item2 .fx-box .bg-icon{
      width: 2.2rem;
      height: 1.1rem;
    }
    .alert-wrap .order-item2 .fx-box .text{
      position: absolute;
      top: 50%;
      width: 2.2rem;
      color: #fff;
      font-size: .42rem;
      text-align: center;
      transform: translateY(-50%);
    }
    .alert-wrap .order-item2 .input-box{
        height: 1.1rem;
        margin-left: .52rem;
        padding: .22rem .38em .22rem .26rem;
        border-radius: .12rem;
        border: 1px solid #313a47;
        box-sizing: border-box;
    }
    .alert-wrap .order-item2 .input-box .input{
        width: 4rem;
        color: #c3c3c3;
        font-size: .42rem;
    }
    .alert-wrap .time-wrap{
        width: 100%;
        height: 2.82rem;
        overflow: hidden;
    }
    .alert-wrap .time-wrap .time-box{
        width: 100%;
        height: 2.82rem;
        white-space: nowrap;
        overflow-x: auto;
    }
    .alert-wrap .time-wrap .time-item{
        position: relative;
        display: inline-block;
        min-width: 2.82rem;
        height: 2.7rem;
        margin-right: .27rem;
        font-size: .39rem;
        border: 2px solid transparent;
        border-radius: .18rem;
        background: #30385d;
        text-align: center;
    }
    .alert-wrap .time-wrap .time-item.active{
        border: 2px solid #4458ed;
    }
    .alert-wrap .time-wrap .time-item .icon{
        position: absolute;
        right: -2px;
        top: -2px;
        width: .84rem;
        height: .78rem;
    }
    .alert-wrap .time-wrap .time-item .t1{
        padding: .36rem .12rem .27rem;
        color: #8e8e8e;
    }
    .alert-wrap .time-wrap .time-item .time{
        color: #4458ed;
    }
    .alert-wrap .time-wrap .time-item .num{
        font-size: .48rem;
    }
    .alert-wrap .time-wrap .time-item .t2{
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: .15rem 0;
        color: #db4949;
        border-radius: 0 0 .18rem .18rem;
        background: rgba(0,0,0,.5);
    }
    .alert-wrap .ky-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .36rem 0;
        color: #c3c3c3;
    }
    .alert-wrap .ky-box .text{
        display: flex;
        align-items: center;
    }
    .alert-wrap .ky-box .text .money{
        /* padding: 0 .3rem; */
    }
    .alert-wrap .ky-box .text .icon{
        width: .6rem;
        height: .6rem;
    }
    .alert-wrap .trade-wrap{
        padding: .6rem 0;
    }
    .alert-wrap .trade-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: .4rem;
    }
    .alert-wrap .trade-box .text{
        width: 33.33%;
        color: #fff;
    }
    .alert-wrap .trade-item{
        padding-top: .42rem;
    }
    .alert-wrap .trade-item .t1{
        color: #fff;
    }
    .alert-wrap .trade-item .t2{
        color: #00c483;
    }
    .alert-wrap .trade-item .t2.active{
        color: #d14b65;
    }
    .alert-wrap .trade-item .t3{
        color: #fff;
    }
    .alert-wrap .trade-item .icon{
      width: .6rem;
      height: .6rem;
      margin-left: .2rem;
      vertical-align: bottom;
    }
    .alert-time-box{
        position: absolute;
        bottom: 0;
        z-index: 1000;
        width: 100%;
        background: #0f1a2a;
    }
    .alert-time-box .alert-item{
        width: 100%;
        height: 1.44rem;
        color: #fff;
        line-height: 1.44rem;
        background: #0f1a2a;
        text-align: center;
    }
    .alert-time-box .alert-item{
        border-bottom: 1px solid #313a47;
    }
    .alert-time-box .alert-item.active{
        color: #218adc;
    }
    .alert-box .btn-cancle{
        margin-top: .18rem;
        border-bottom: none;
    }
</style>



// WEBPACK FOOTER //
// src/pages/positionList.vue